






















































import {
  ModalMixin, Modal, HasTaskMixin, AsyncBtn, notify,
} from 'mycorems-app-shared';
import { add } from '.';
import { ModalElement, Account, Country } from '../types';
import SelectCountry from '../country/SelectCountry.vue';

interface Data {
  tab: number,
  account: {
    parentId: string,
    name: string|null,
    address: {
      country: object,
    }
    contact: object,
    type: number,
  },
  selectedCountry: Country|null,
}

export default HasTaskMixin.extend({
  mixins: [ModalMixin],
  props: {
    parentId: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: 'New Account',
    },
  },
  data(): Data {
    return {
      tab: 0,
      account: {
        name: null,
        parentId: this.parentId,
        address: {
          country: {},
        },
        contact: {},
        type: this.type,
      },
      selectedCountry: null,
    };
  },
  watch: {
    selectedCountry: {
      handler(country): void {
        this.account.address.country = country;
      },
      immediate: true,
    },
  },
  computed: {
    title(): string {
      if (!this.account.name) return this.label;
      return `${this.label} - ${this.account.name}`;
    },
    isFirstStep(): boolean {
      return (this.tab === 0);
    },
    isLastStep(): boolean {
      return (this.tab === 2);
    },
  },
  methods: {
    prev(): void {
      this.tab -= 1;
    },
    next(): void {
      this.tab += 1;
    },
    create(): void {
      this.task = add(this.account);
      this.task.then((account: Account) => {
        this.$emit('ok', account);
        (this.$refs.modal as ModalElement).hide();
        notify.success(`${account.name} has been created.`);
      });
    },
  },
  components: {
    Modal,
    SelectCountry,
    AsyncBtn,
  },
});
